export const FETCH_ROLE_MENU_PERMISSIONS_REQUEST = 'FETCH_ROLE_MENU_PERMISSIONS_REQUEST';
export const FETCH_ROLE_MENU_PERMISSIONS_SUCCESS = 'FETCH_ROLE_MENU_PERMISSIONS_SUCCESS';
export const FETCH_ROLE_MENU_PERMISSIONS_FAILURE = 'FETCH_ROLE_MENU_PERMISSIONS_FAILURE'; 